import styles from "./Footer.module.css"
import { Link } from "react-router-dom";

export default function Footer({bgColor, fontColor}) {
    
    return (
        <footer className={styles.footer} style={{ "--bgColor": bgColor, "--fontColor": fontColor }}>
            <div className={styles.footerLeft}>
              © 2025 alwinowitch – Alle Rechte vorbehalten.
              <Link to="/datenschutz">Datenschutz</Link>
              <Link to="/impressum">Impressum</Link>
              Website von Timo Müller
            </div>
            <div className={styles.footerIcons}>
                <a className={styles.socialIcon} href="https://www.youtube.com/channel/UCQN9zbCfTgRbYaUjI_lJlvA" target="_blank" rel="noopener noreferrer"><i className="bi bi-youtube"></i></a>
                <a className={styles.socialIcon} href="https://soundcloud.com/alwinowitch" target="_blank" rel="noopener noreferrer"><i className="bi bi-soundcloud"></i></a>
                <a className={styles.socialIcon} href="https://open.spotify.com/intl-de/artist/3bUiiFAMU2mzToyw0ADEdj?si=573cc289b4534367" target="_blank" rel="noopener noreferrer"><i className="bi bi-spotify"></i></a>
                <a className={styles.socialIcon} href="https://music.apple.com/de/artist/alwinowitch/1737302812" target="_blank" rel="noopener noreferrer"><i className="bi bi-apple"></i></a>
                <a className={styles.socialIcon} href="https://www.instagram.com/alwinowitch/" target="_blank" rel="noopener noreferrer"><i className="bi bi-instagram"></i></a>
                <a className={styles.socialIcon} href="https://www.tiktok.com/@alwin_mc_burger" target="_blank" rel="noopener noreferrer"><i className="bi bi-tiktok"></i></a>
                <a className={styles.socialIcon} href="https://music.youtube.com/channel/UCzoIhrVkr6nWUTphVcjpz4A" target="_blank" rel="noopener noreferrer"><i className="bi bi-google"></i></a>
            </div>
        </footer>
    );
}